/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Free_FeatureInputs */

const en_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 calls)`)
};

const id_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Panggilan 1-1)`)
};

const ms_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(panggilan 1-1)`)
};

const ca_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(trucades 1-1)`)
};

const cs_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(hovory jeden na jednoho)`)
};

const da_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 opkald)`)
};

const de_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Einzelgespräche)`)
};

const et_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(üks ühele kõned)`)
};

const es_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(llamadas 1-1)`)
};

const fr_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(appels individuels)`)
};

const hr_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(razgovori 1 na 1)`)
};

const it_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(chiamate 1-1)`)
};

const lv_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(zvani divatā)`)
};

const lt_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Skambučiai poromis)`)
};

const hu_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 hívás)`)
};

const nl_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 gesprekken)`)
};

const nb_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(En-til-en-samtaler)`)
};

const pl_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(połączenia dwuosobowe)`)
};

const pt_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(chamadas individuais)`)
};

const ro_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Apeluri 1-1)`)
};

const sk_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(hovory 1 na 1)`)
};

const sl_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(klici 1 na 1)`)
};

const fi_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(kahdenkeskeiset puhelut)`)
};

const sv_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 samtal)`)
};

const vi_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Cuộc gọi 1-1)`)
};

const tr_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1'e 1 görüşmeler)`)
};

const el_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(κλήσεις 1-1)`)
};

const bg_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Разговори 1 на 1)`)
};

const ru_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 звонки)`)
};

const sr_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(позиви 1 на 1)`)
};

const uk_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 дзвінки)`)
};

const ka_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 ზარები)`)
};

const hi_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(१-१ कॉल्स)`)
};

const th_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(การโทร 1-1)`)
};

const ko_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(일대일 통화)`)
};

const zh_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（1-1 通话）`)
};

const zh_tw_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(1-1 通話)`)
};

const ja_talk_free_feature = /** @type {(inputs: Talk_Free_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（1-1通話）`)
};

/**
* | output |
* | --- |
* | "(1-1 calls)" |
*
* @param {Talk_Free_FeatureInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_free_feature = /** @type {((inputs?: Talk_Free_FeatureInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Free_FeatureInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_free_feature(inputs)
	if (locale === "ms") return ms_talk_free_feature(inputs)
	if (locale === "ca") return ca_talk_free_feature(inputs)
	if (locale === "cs") return cs_talk_free_feature(inputs)
	if (locale === "da") return da_talk_free_feature(inputs)
	if (locale === "de") return de_talk_free_feature(inputs)
	if (locale === "et") return et_talk_free_feature(inputs)
	if (locale === "es") return es_talk_free_feature(inputs)
	if (locale === "fr") return fr_talk_free_feature(inputs)
	if (locale === "hr") return hr_talk_free_feature(inputs)
	if (locale === "it") return it_talk_free_feature(inputs)
	if (locale === "lv") return lv_talk_free_feature(inputs)
	if (locale === "lt") return lt_talk_free_feature(inputs)
	if (locale === "hu") return hu_talk_free_feature(inputs)
	if (locale === "nl") return nl_talk_free_feature(inputs)
	if (locale === "nb") return nb_talk_free_feature(inputs)
	if (locale === "pl") return pl_talk_free_feature(inputs)
	if (locale === "pt") return pt_talk_free_feature(inputs)
	if (locale === "ro") return ro_talk_free_feature(inputs)
	if (locale === "sk") return sk_talk_free_feature(inputs)
	if (locale === "sl") return sl_talk_free_feature(inputs)
	if (locale === "fi") return fi_talk_free_feature(inputs)
	if (locale === "sv") return sv_talk_free_feature(inputs)
	if (locale === "vi") return vi_talk_free_feature(inputs)
	if (locale === "tr") return tr_talk_free_feature(inputs)
	if (locale === "el") return el_talk_free_feature(inputs)
	if (locale === "bg") return bg_talk_free_feature(inputs)
	if (locale === "ru") return ru_talk_free_feature(inputs)
	if (locale === "sr") return sr_talk_free_feature(inputs)
	if (locale === "uk") return uk_talk_free_feature(inputs)
	if (locale === "ka") return ka_talk_free_feature(inputs)
	if (locale === "hi") return hi_talk_free_feature(inputs)
	if (locale === "th") return th_talk_free_feature(inputs)
	if (locale === "ko") return ko_talk_free_feature(inputs)
	if (locale === "zh") return zh_talk_free_feature(inputs)
	if (locale === "zh-tw") return zh_tw_talk_free_feature(inputs)
	if (locale === "ja") return ja_talk_free_feature(inputs)
	return en_talk_free_feature(inputs)
});